import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ServicioComprobanteInformeService, Cajero, Sedes,
  FiltroComprobanteInforme
} from '../../../services/servicio-comprobante-informe.service';
import { AlertModel, ETipoAlert } from '../../shared/alert/alert.component';


@Component({
  selector: 'app-header-comprobante-informe',
  templateUrl: './header-comprobante-informe.component.html',
  styleUrls: ['./header-comprobante-informe.component.css']
})
export class HeaderComprobanteInformeComponent implements OnInit {

  @Input() public objetoDatosEntity: FiltroComprobanteInforme;
  @Output() generar = new EventEmitter<FiltroComprobanteInforme>();
  @Output() emitError = new EventEmitter<AlertModel>();
  @Output() emitCsv = new EventEmitter();

  alert: AlertModel = new AlertModel;
  cajerosItem: SelectItem[] = [];
  sedesItem: SelectItem[] = [];

  cajerosSelected: SelectItem[] = [];
  sedesSelected: SelectItem[] = [];
  fecha = new Date();

  loading: boolean; // Indicador de carga en header
  mensaje: String = 'Cargando...';

  constructor(private servicioComprobanteInforme: ServicioComprobanteInformeService) {
  }

  ngOnInit() {
    this.getCajeros();
    this.getSedes();
  }

  errorRequest(mensaje: string) {
    this.alert = {
      mensaje,
      tipo: ETipoAlert.danger,
      visible: true
    }
    this.emitError.emit(this.alert);
  }

  async getCajeros() {
    try {
      const response = await this.servicioComprobanteInforme.getCajeros(this.objetoDatosEntity);
      if (response !== null) {
        response.subscribe((data: Cajero[]) => {
          this.loading = false;
          this.cajerosItem = [];
          this.mensaje = 'cargando...';
          for (const cajetoTmp of data) {
            this.cajerosItem.push({ label: cajetoTmp.nombre, value: cajetoTmp.unco });
          }
          const cajeroDefault: any = parseInt(this.objetoDatosEntity.uncoLogin.split(',')[0]);
          this.cajerosSelected.push(cajeroDefault)

        }, (err: HttpErrorResponse) => {
          this.loading = false;
          this.errorRequest('Error grave al obtener los cajeros, reporte caso al administrador')
          console.error('Error cajeros', err);
          if (err.status === 500) {
            this.cajerosItem = [];
          } else {
            console.error(err);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getSedes() {
    let response = await this.servicioComprobanteInforme.getSedes(this.objetoDatosEntity);
    if (response != null) {
      response.subscribe((sedes: Sedes[]) => {
        for (const sede of sedes) {
          let selectItem: SelectItem = {
            label: sede.descripcionCorta,
            value: sede.unco
          }
          this.sedesItem.push(selectItem);
        }
        const sedeDefault: any = parseInt(this.objetoDatosEntity.uncoSede.split(',')[0]);
        this.sedesSelected.push(sedeDefault)
      }, (err: HttpErrorResponse) => {
        console.error('Error Sedes', err);
        this.errorRequest('Error grave al obtener las sedes, reporte caso al administrador')
        if (err.status === 500) {
          this.sedesItem = [];
          this.loading = false;
        } else {
          console.error(err);
        }
      });
    }
  }

  onGenerar() {
    if (this.fecha === null) {
      alert("Especifique un valor para el parámetro 'Fecha Informe '. El parámetro no puede estar en blanco.");
    } else if (this.cajerosSelected.length === 0) {
      alert("Especifique un valor para el parámetro 'Cajero'. El parámetro no puede estar en blanco.");
    } else if (this.sedesSelected.length === 0) {
      alert("Especifique un valor para el parámetro 'Sedes'. El parámetro no puede estar en blanco.");
    } else {
      this.objetoDatosEntity.fecha = this.fecha;
      this.objetoDatosEntity.uncoLogin = String(this.cajerosSelected);
      this.objetoDatosEntity.uncoSede = String(this.sedesSelected);
      this.generar.emit(this.objetoDatosEntity);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('comprobante-informe-print').innerHTML;

    printContents = printContents.replace('table-responsive', '');

    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
        <html>
          <head>
            <title> Standard Health | Reportes </title>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
            integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
            <style>
              /* Tamaños fuentes */
  
              .font-title {
                  font-size: 150px;
              }
  
              .font-subtitle {
                  font-size: 30px;
              }
  
              .font-normal {
                  font-size: 16px;
              }
            </style>
          </head>
          <body onload="window.print();window.close()">${ printContents}</body>
        </html>`
    );
    popupWin.document.close();
  }

  OnGenerarCSV() {
    this.emitCsv.emit()
  }
}
